import * as ErrorLog from './ErrorLog/index';
import * as Users from './Users/index';
import * as Roles from './Roles/index';
import * as AuditLog from './AuditLog/index';
import * as Customers from './Customers/index';
import * as FreeRoundCampaigns from './FreeRoundCampaigns/index';
import * as Players from './Players/index';
import * as Games from './Games/index';
import * as Channels from './Channels/index';
import * as Platforms from './Platforms/index';
import * as RequestLog from './RequestLog/index';
import * as ConfigurationImport from './ConfigurationImport/index';
import * as FreeRoundConfigurationImport from './FreeRoundConfigurationImport/index';
import * as Logs from './Logs/index';
import * as FrontofficeUsers from './FrontofficeUsers/index';
import * as GameBuildConfiguration from './GameBuildConfiguration/index';
import * as ProgressiveBonuses from './ProgressiveBonuses/index';
import * as Reviews from './Reviews/index';
import * as Jurisdictions from './Jurisdictions/index';
import * as ConfigurationOverview from './ConfigurationOverview/index';
import * as GamePresentation from './GamePresentation/index';
import * as ConfigurationCleanup from './ConfigurationCleanup/index';
import * as GameConfigurations from './GameConfigurations/index';
import * as GameClientVersions from './GameClientVersions/index'

export {
ErrorLog,
Users,
Roles,
AuditLog,
Customers,
Players,
Games,
Channels,
Platforms,
RequestLog,
ConfigurationImport,
FreeRoundConfigurationImport,
Logs,
FrontofficeUsers,
FreeRoundCampaigns,
GameBuildConfiguration,
ProgressiveBonuses,
Reviews,
Jurisdictions,
ConfigurationOverview,
GamePresentation,
ConfigurationCleanup,
GameConfigurations,
GameClientVersions
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/index.ts
 **/